/* eslint-disable no-useless-catch */
import { API } from "../api";
import { HUBS_URL } from "../constants/url.constant";

export const GET_HUBS = "GET_HUBS";
export const ADD_HUB = "ADD_HUB";
export const DELETE_HUB = "DELETE_HUB";
export const UPDATE_HUB = "UPDATE_HUB";

export const getHubs = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(HUBS_URL, {
        params
      });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_HUBS,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addHub = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(HUBS_URL, data);
      dispatch({
        type: ADD_HUB,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateHub = (code, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${HUBS_URL}/${code}`, body);
      dispatch({ type: UPDATE_HUB, payload: { code, ...body } });
    } catch (error) {
      throw error;
    }
  };
};

export const removeHub = (hubCode) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${HUBS_URL}/${hubCode}`);
      dispatch({
        type: DELETE_HUB,
        payload: hubCode
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { hubTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_HUBS:
      return {
        ...state,
        hubTableColumns: payload.columns,
        hubTableRows: payload.rows,
        totalRows: payload.count
      };
    case ADD_HUB:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        hubTableRows: [...state.hubTableRows, { ...payload }]
      };
    case DELETE_HUB:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        hubTableRows: state.hubTableRows.filter((hub) => hub.code !== payload)
      };
    case UPDATE_HUB:
      return {
        ...state,
        hubTableRows: state.hubTableRows.map((hub) =>
          hub.code === payload.code
            ? { "region.country.name": hub["region.country.name"], ...payload }
            : hub
        )
      };
    default:
      return state;
  }
}
